import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { SharedModule } from './../shared/modules/shared.module';
import { MomentModule } from 'ngx-moment';
import { UnsubscribeService } from './unsubscribe.service';
import { UnsubscribeComponent } from './unsubscribe.component';
import { NgxMaskDirective, provideNgxMask } from 'ngx-mask';

@NgModule({
    imports: [
      SharedModule,
      RouterModule,
      NgxMaskDirective,
      MomentModule
    ],
    providers: [UnsubscribeService, provideNgxMask()],
    declarations: [
      UnsubscribeComponent
    ]
  })
  export class UnsubscribeModule { }